import { Flex } from "antd"

import { useBusinessAccount } from "../../../../User/hooks/useBusinessAccount"
import { useIsStripeConnected } from "../../hooks/useIsStripeConnected"
import MastercardEstimatedProgramStatus from "../EstimatedProgramStatus/MastercardEstimatedProgramStatus"
import MCChartBlock from "../MCChartBlock/MCChartBlock"
import EFMMonitoringProgram from "../MonitoringProgram/EFMMonitoringProgram"
import MastercardMonitoringProgram from "../MonitoringProgram/MastercardMonitoringProgram"
import MastercardSectionHeader from "./MastercardSectionHeader"
import NoBusinessAccountPlaceholder from "./NoBusinessAccountPlaceholder"

import "./MastercardMonitoringSection.less"

const MastercardMonitoringSection = ({ filters, business_account_id }) => {
  // Keeps state.user.businessAccount (and its connected_payment_processors)
  // fresh after switching business accounts — HealthMonitoringPage itself
  // never re-fetches it, unlike Dashboard/Configure/Integrations pages.
  useBusinessAccount()
  const isStripeConnected = useIsStripeConnected()

  if (!business_account_id) {
    return (
      <Flex vertical gap={16} className="mc-monitoring-section">
        <NoBusinessAccountPlaceholder />
      </Flex>
    )
  }

  return (
    <Flex vertical gap={16} className="mc-monitoring-section">
      {!isStripeConnected && <MastercardSectionHeader />}
      <Flex vertical gap={40}>
        <MCChartBlock filters={filters} business_account_id={business_account_id} />
        <MastercardMonitoringProgram business_account_id={business_account_id} />
        <EFMMonitoringProgram business_account_id={business_account_id} />
        <MastercardEstimatedProgramStatus business_account_id={business_account_id} />
      </Flex>
    </Flex>
  )
}

export default MastercardMonitoringSection
